import { render, staticRenderFns } from "./ntmModal.vue?vue&type=template&id=dbd430f0&scoped=true"
import script from "./ntmModal.vue?vue&type=script&lang=js"
export * from "./ntmModal.vue?vue&type=script&lang=js"
import style0 from "./ntmModal.vue?vue&type=style&index=0&id=dbd430f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd430f0",
  null
  
)

export default component.exports